import Image from "next/image";
import { Header } from "../header";
import { Button } from "@workspace/ui/components/button";

export function HealthConditionsExplainer2({
  title,
  image,
  handleNext,
  sub_description,
}: {
  title: string;
  image: string;
  handleNext: () => void;
  sub_description: string;
}) {
  return (
    <>
      <div className="flex flex-1 flex-col gap-5 overflow-y-auto min-h-0 pb-12">
        <Header title={title} />
        <div>
          <div className="relative h-[420px] md:h-[600px] w-full">
            <Image
              src={image}
              alt="health-conditions"
              fill
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6 bg-white">
        <p className="text-[#7F8598] text-center title-12"
        id="hint-text"
        data-testid="hint-text"
        >
          {sub_description}
        </p>
        <Button onClick={handleNext} variant="default" className="w-full">How to track?</Button>
      </div>
    </>
  );
}
